/// <reference path="../components/quotesdma.jsx" />
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import MainNavbar from "utils/Navbars/MainNavbar.js";
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";
import { useCookies } from 'react-cookie';
/*import "../assets/css/loader.css";*/
import { useHistory } from "react-router-dom";
import Cancellations_PolicyCount from "components/Cancellations_PolicyCount";
import Cancellations_Premiums from "components/Cancellations_Premiums";

const useStyles = makeStyles(styles);

export default function Pages(props) {
    const [cookies, setCookie] = useCookies(['auth']);
    
    //Event Handlers
    const changeStartDate = (date) => {
        setStartDate((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    };

    const changeEndDate = (date) => {
        setEndDate((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    };

    const changeCall = () => {
        setCall("true");
    };
    
    //State Variables 
    var date = new Date();
    const [startDate, setStartDate] = React.useState((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    const [endDate, setEndDate] = React.useState((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    const [call, setCall] = React.useState(false);

    const { ...rest } = props;
    // ref for the wrapper div
    const wrapper = React.createRef();
    // styles
    const classes = useStyles();

    React.useEffect(() => {
        return () => {
            setCall("false");
        };
    }, [call]);

    //Utility functions
    const getActiveRoute = routes => {
        let activeRoute = "Default Brand Text";
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveRoute = getActiveRoute(routes[i].views);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute;
                }
            } else {
                if (
                    window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
                ) {
                    return routes[i].name;
                }
            }
        }
        return activeRoute;
    }
    const history = useHistory();
    if (cookies.pass == undefined) {
        history.push('/');
    }
    //Utility functions End

    return (
        <div>
            <div className={classes.wrapper} ref={wrapper}>
                <MainNavbar state="MI" onChangeCall={changeCall} onChangeStartDate={changeStartDate} onChangeEndDate={changeEndDate} startDate={startDate} endDate={endDate} Text={"Michigan Dashboard"} {...rest} />
                <div>
                    <Cancellations_PolicyCount
                        call={call}
                        startDate={startDate}
                        endDate={endDate}
                        states={["MI"]}
                    />
                    <Cancellations_Premiums
                        call={call}
                        startDate={startDate}
                        endDate={endDate}
                        states={["MI"]}
                    />
                </div>
            </div>
        </div>
    );
}